const LevelEndType = {};
export default LevelEndType;

LevelEndType.TIMEOUT = "timeout";
LevelEndType.USER = "user";